



import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "BaseFormSubtitle",
  props: {
    label: { type: String, default: "" },
    tag: { type: String, default: "h3" },
  },
});
